import Category from "../../../common/NodeTree/Category";

const NodeList = ({nodeTree, nodes}) => {
	return (
		<div>
			{Object.entries(nodeTree).map(([categoryId, childNodeIds]) => {
				return <Category key={categoryId}
				                 nodes={nodes}
				                 node={nodes[categoryId]}
				                 childNodeIds={childNodeIds}
				/>;
			})}
		</div>
	);
}

export default NodeList;